import { getViewportInfo, isClient } from '@tcp/core/src/utils';
import { getByomMediaBorderRadius } from '@tcp/core/src/utils/utils.web';
import isEmpty from 'lodash/isEmpty';

export const imgVideoData = ({
  image,
  mediaBorderRadiusOverride,
  video,
  imageMobile,
  videoMobile,
}) => {
  const imgData =
    !isEmpty(image) && !isEmpty(mediaBorderRadiusOverride)
      ? Object.assign(image, mediaBorderRadiusOverride)
      : image;
  const videoData =
    !isEmpty(video) && !isEmpty(mediaBorderRadiusOverride)
      ? Object.assign(video, mediaBorderRadiusOverride)
      : video;
  const imgMData =
    !isEmpty(imageMobile) && !isEmpty(mediaBorderRadiusOverride)
      ? Object.assign(imageMobile, mediaBorderRadiusOverride)
      : imageMobile;
  const videoMData =
    !isEmpty(videoMobile) && !isEmpty(mediaBorderRadiusOverride)
      ? Object.assign(videoMobile, mediaBorderRadiusOverride)
      : videoMobile;

  return {
    imgData,
    videoData,
    imgMData,
    videoMData,
  };
};

export const getMediaBorderRadiusOverride = (
  isHpNewModuleDesignEnabled,
  styleOverrides,
  overrideMap
) => {
  if (isHpNewModuleDesignEnabled && styleOverrides && overrideMap) {
    return getByomMediaBorderRadius(
      styleOverrides[overrideMap[0]],
      styleOverrides[overrideMap[1]],
      styleOverrides[overrideMap[2]],
      styleOverrides[overrideMap[3]]
    );
  }
  return {};
};

export const renderDifferentImageOnMobile = (showDifferentImageOnMobile, showVideoOnMobile) => {
  const { isMobile } = getViewportInfo() || {};
  return isClient() && isMobile && showDifferentImageOnMobile && !showVideoOnMobile;
};

export const getClassName = (isOnlyImage) => `${isOnlyImage ? 'single-image' : null}`;

export const getScrollIdentifier = (isOnScrollAnimationEnabled, isOnScrolledChecked) => {
  return isOnScrollAnimationEnabled && isOnScrolledChecked;
};

export const getScrollIdentifierID = (isOnScrollAnimation, videoData, videoMobile, slotIndex) => {
  return isOnScrollAnimation && (videoData || videoMobile)
    ? `byom_animation_video_slot_${slotIndex}`
    : '';
};

export const getSearchCTA = (isSearchsingleCTAButton) => {
  return isSearchsingleCTAButton && isSearchsingleCTAButton[1] === 'search';
};

export const getModuleQVCheck = (target, action) => {
  const DEFAULT_RESPONSE = { isModuleQVEnabled: false, moduleQVProductId: null };

  if (target !== '_modal' || !action) {
    return DEFAULT_RESPONSE;
  }

  const match = action.toUpperCase().match(/^QV#([\w\d_]+)/);
  return match ? { isModuleQVEnabled: true, moduleQVProductId: match[1] } : DEFAULT_RESPONSE;
};
